import axios from 'axios'

class AuthAPI {
  login = async data => {
    return axios.post('api/admin/login', data)
  }
}

export const authAPI = new AuthAPI()
